import { useState, useEffect } from 'react';

type OfflineAttemptCallback = () => void;
const listeners: Set<OfflineAttemptCallback> = new Set();

export function onOfflineAttempt(cb: OfflineAttemptCallback): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function notifyOfflineMutationBlocked(): void {
  listeners.forEach((cb) => cb());
}

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
